import React from "react";
import RadarRounded from "@mui/icons-material/RadarRounded";
import AccountBalanceRounded from "@mui/icons-material/AccountBalanceRounded";
import EngineeringRounded from "@mui/icons-material/EngineeringRounded";

import useInView from "hooks/useInView";
import "./features.scss";

const FEATURES = [
  {
    title: "Deal Finder",
    description:
      "MLS feeds, county assessor records, permit histories, and pre-foreclosure filings — the data you'd spend hours collecting yourself, aggregated and scored automatically.",
    tag: "Multi-source deal scoring",
    Icon: RadarRounded,
  },
  {
    title: "Lender Matching",
    description:
      "Estimated financing options based on current hard money and DSCR market conditions — rates, leverage, and closing timelines attached to every property.",
    tag: "Financing estimates",
    Icon: AccountBalanceRounded,
  },
  {
    title: "Contractor Scores",
    description:
      "Scored on actual project outcomes: budget accuracy, on-time delivery, and inspection results. The kind of track record data that only repeat investors used to have access to.",
    tag: "Outcome-based scoring",
    Icon: EngineeringRounded,
  },
];

const FeatureCard = ({ title, description, tag, Icon }) => {
  const [ref, inView] = useInView();

  return (
    <div ref={ref} className={`feature-card ${inView ? "visible" : ""}`}>
      <div className="feature-header">
        <div className="feature-icon">
          <Icon />
        </div>
        <span className="feature-tag">{tag}</span>
      </div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  );
};

const Features = () => (
  <section id="features" className="features">
    <div className="features-inner">
      <h2 className="features-heading">
        Everything between finding a deal and closing it.
      </h2>
      <div className="features-grid">
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>
    </div>
  </section>
);

export default Features;
